module.exports = __webpack_public_path__ + "media/0007.6b061d63.mp3";